













































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import ContentComposer from '@/views/browse-and-go/components/ContentComposer.vue'
import { cloneData } from '@/services/browse-and-go/labels'
import { bngState, deleteSelection, saveSelection } from '@/services/browse-and-go/store'
import { SavedSelection } from '@/services/browse-and-go/types'

function blankSelection(): SavedSelection {
  return { id: '', name: '', itemIds: [] }
}

@Component({
  name: 'BrowseAndGoSelectionEdit',
  components: { PageHeader, ContentComposer }
})
export default class extends Vue {
  private draft: SavedSelection = blankSelection()
  private ready = false

  get isCreate() {
    return this.$route.name === 'BrowseAndGoSelectionCreate'
  }

  get merchants() {
    return bngState.merchants
  }

  get categories() {
    return bngState.categories
  }

  get otherSelections() {
    return bngState.selections.filter(selection => selection.id !== this.draft.id)
  }

  @Watch('$route.fullPath', { immediate: true })
  private load() {
    if (this.isCreate) {
      const raw = this.$route.query.items
      const requested = typeof raw === 'string' ? raw.split(',').filter(Boolean) : []
      const known = new Set(bngState.merchants.map(merchant => merchant.id))
      this.draft = blankSelection()
      this.draft.itemIds = requested.filter(id => known.has(id))
      this.ready = true
      return
    }
    const selection = bngState.selections.find(item => item.id === String(this.$route.params.id || ''))
    if (!selection) {
      this.$message.error('Sélection introuvable')
      this.$router.replace({ name: 'BrowseAndGoSelections' })
      return
    }
    this.draft = cloneData(selection)
    this.ready = true
  }

  private onAddIds(ids: string[]) {
    this.draft.itemIds = Array.from(new Set([...this.draft.itemIds, ...ids]))
  }

  private onRemove(id: string) {
    this.draft.itemIds = this.draft.itemIds.filter(item => item !== id)
  }

  private onClear() {
    this.draft.itemIds = []
  }

  private cancel() {
    this.$router.push({ name: 'BrowseAndGoSelections' })
  }

  private save() {
    this.draft.name = this.draft.name.trim()
    if (!this.draft.name) {
      this.$message.error('Le nom est obligatoire')
      return
    }
    saveSelection(this.draft)
    this.$message.success('Sélection enregistrée')
    this.$router.push({ name: 'BrowseAndGoSelections' })
  }

  private remove() {
    this.$confirm(
      'Supprimer cette sélection enregistrée ? Les modèles déjà composés ne seront pas modifiés.',
      'Supprimer',
      { type: 'warning', confirmButtonText: 'Supprimer', cancelButtonText: 'Annuler' }
    ).then(() => {
      deleteSelection(this.draft.id)
      this.$message.success('Sélection supprimée')
      this.$router.push({ name: 'BrowseAndGoSelections' })
    }).catch(() => undefined)
  }
}
